import React from 'react';
import { Star } from 'lucide-react';
import { Badge } from '../ui/badge';
import { formatDateTime } from '../../lib/dateUtils';

export const ROLE_LABEL = { parent: 'Parent', driver: 'Driver', transport: 'Transport Operator', it: 'IT', admin: 'Admin', master_admin: 'Master Admin' };

const STATUS = {
  pending: ['Under review', 'bg-slate-500'],
  published: ['Published', 'bg-emerald-600'],
  private: ['Kept private', 'bg-gray-600'],
  with_admin: ['Sent to Admin', 'bg-indigo-600'],
  with_master_admin: ['Sent to Master Admin', 'bg-purple-600'],
  handled: ['Handled', 'bg-sky-600'],
};

const ACTION_LABEL = {
  submitted: 'Submitted', published: 'Published', kept_private: 'Kept private', unpublished: 'Unpublished',
  sent_to_admin: 'Sent to Admin', escalated: 'Escalated to Master Admin', handled: 'Handled',
};

export const StatusBadge = ({ status, testId }) => {
  const [label, cls] = STATUS[status] || [status, 'bg-slate-500'];
  return <Badge className={`${cls} text-white`} data-testid={testId}>{label}</Badge>;
};

export const Stars = ({ value, onChange, size = 'w-5 h-5', testId }) => (
  <div className="flex items-center gap-0.5" data-testid={testId}>
    {[1, 2, 3, 4, 5].map((n) => (
      <button key={n} type="button" disabled={!onChange} onClick={() => onChange?.(n)}
              className={onChange ? 'cursor-pointer transition-transform hover:scale-110' : 'cursor-default'}
              aria-label={`${n} star${n > 1 ? 's' : ''}`} data-testid={testId ? `${testId}-${n}` : undefined}>
        <Star className={`${size} ${n <= value ? 'fill-amber-400 text-amber-400' : 'text-slate-300'}`} />
      </button>
    ))}
  </div>
);

export const ReviewTrail = ({ trail }) => (
  <ol className="border-l-2 border-slate-200 ml-1 pl-3 space-y-1" data-testid="review-trail">
    {(trail || []).map((t, i) => (
      <li key={i} className="text-xs text-muted-foreground">
        <span className="font-medium text-foreground">{ACTION_LABEL[t.action] || t.action}</span>
        {' '}by {t.by_name} ({ROLE_LABEL[t.by_role] || t.by_role})
        {t.to_role && t.action !== 'submitted' && t.action !== 'handled' ? ` → ${ROLE_LABEL[t.to_role]}` : ''}
        {' · '}{formatDateTime(t.at)}
        {t.note ? <span className="block italic">“{t.note}”</span> : null}
      </li>
    ))}
  </ol>
);
